import { render, staticRenderFns } from "./ProductVideo.vue?vue&type=template&id=749a4f86&scoped=true&"
import script from "./ProductVideo.vue?vue&type=script&lang=ts&"
export * from "./ProductVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ProductVideo.vue?vue&type=style&index=0&id=749a4f86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a4f86",
  null
  
)

export default component.exports